<template>
  <div class="Production-Plan">
    <PageTitle imagem="efetuarplanejamento.png" main="Efetuar Planejamento da Produção" sub="" />
    <ProductionPlanCreatorEditor />
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import ProductionPlanCreatorEditor from "./productionPlanCreatorEditor";

export default {
  name: "productionPlan",
  components: { PageTitle, ProductionPlanCreatorEditor },
};
</script>


<style>
#reachGoal {
  min-width: 450px;
}
</style>